module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Book-5e662f76d63c0b0dd8a0fdfddbf78da5.svg";